'use client';

import { ReactNode } from 'react';

import { Footer } from '@/modules/footer';

interface ServiceLayoutProps {
  children: ReactNode;
}

export function ServiceLayout({ children }: ServiceLayoutProps) {
  return (
    <>
      <main className="relative overflow-x-hidden">{children}</main>
      <Footer />
    </>
  );
}
